import { useEffect, useRef } from 'react';

import { cn } from '@blockworks/ui/utils';

import { ContainerDef } from '@/components/ads/ad-container-ids';
import useAdSlot from '@/components/ads/hooks/use-ad-slot';

type EventCardProps = {
    className?: string;
    googleAd: ContainerDef;
    children?: React.ReactNode;
    onAdRendered?: () => void;
};

const defaultOptions = { collapse: true, collapseBeforeAdFetch: true, label: true };

const AdContainer = ({ children, className, googleAd, onAdRendered }: EventCardProps) => {
    const { options = {} } = googleAd;
    const slotOptions = { ...defaultOptions, ...options };
    const { label } = slotOptions;

    const insRef = useRef<HTMLDivElement | null>(null);
    const attrs = useAdSlot(googleAd);

    useEffect(() => {
        if (!onAdRendered || !insRef.current) return;

        const observer = new MutationObserver(() => {
            if (insRef.current?.children.length) {
                onAdRendered();
                observer.disconnect();
            }
        });

        observer.observe(insRef.current, { childList: true });

        return () => observer.disconnect();
    }, [onAdRendered]);

    return (
        <ins ref={insRef as any} {...attrs} className={cn('ad-slot', label ? 'ad-slot-label' : null, className)}>
            {children}
        </ins>
    );
};

export default AdContainer;
